import { ArrowsInSimple, ArrowsOutSimple, CaretRight, MagnifyingGlass } from '@phosphor-icons/react';
import { useLocation } from 'react-router-dom';

const WORKSPACES = {
  'command-center': ['Operations', 'Command Center'], tasks: ['Operations', 'Tasks'],
  documents: ['Operations', 'Documents'], finance: ['Operations', 'Finance'],
  telegram: ['Operations', 'Send Alert'], review: ['Operations', 'Sunday Review'],
  'reels-operations': ['Traffic', 'Reels Operations'], scheduler: ['Traffic', 'Schedule'],
  'reddit-operations': ['Traffic', 'Reddit Operations'],
  'sales-overview': ['Sales', 'Sales Overview'], chatters: ['Sales', 'Chatters'], pipeline: ['Sales', 'Pipeline'],
  onboarding: ['Models', 'Model Onboarding'], 'models-hub': ['Models', 'Models Hub'],
  'creator-operations': ['Models', 'Creator Operations'],
  'content-os': ['Tools', 'Content OS'], knowledge: ['Tools', 'Knowledge'],
  'ai-content': ['Tools', 'AI Generator'], settings: ['Workspace', 'Settings'],
};

export default function WorkspaceBar({ compact, onToggleFocus, isMobile }) {
  const { pathname } = useLocation();
  const [group, title] = WORKSPACES[pathname.split('/')[1]] || ['CUZO', 'Workspace'];
  return <header className="workspace-bar">
    <div className="workspace-bar__location" aria-label={`Current workspace: ${title}`}>
      <span className="workspace-bar__group">{group}</span><CaretRight size={12} aria-hidden="true" />
      <strong>{title}</strong>
    </div>
    <div className="workspace-bar__actions">
      <button type="button" className="workspace-bar__search" onClick={() => window.dispatchEvent(new Event('cuzo:open-navigation'))} aria-label="Find a workspace">
        <MagnifyingGlass size={16} aria-hidden="true" /><span>Jump to…</span><kbd>⌘ / Ctrl K</kbd>
      </button>
      {!isMobile && <button type="button" className={`workspace-bar__focus${compact ? ' is-on' : ''}`} onClick={onToggleFocus} aria-pressed={compact} title={compact ? 'Expand navigation' : 'Make more room for your work'}>
        {compact ? <ArrowsOutSimple size={16} aria-hidden="true" /> : <ArrowsInSimple size={16} aria-hidden="true" />}
        <span>{compact ? 'Exit focus' : 'Focus mode'}</span>
      </button>}
    </div>
  </header>;
}
